const SentIcon = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{flexShrink: 0}}
    >
      <path
        d="M15.7858 2.2897C14.1522 0.530522 1.86486 4.8399 1.87501 6.41325C1.88651 8.1974 6.67356 8.74629 8.00042 9.11854C8.79832 9.3424 9.01202 9.57184 9.196 10.4086C10.0292 14.1979 10.4476 16.0826 11.401 16.1247C12.9208 16.1919 17.38 4.0065 15.7858 2.2897Z"
        stroke="#30970B"
        stroke-width="1.125"
      />
      <path
        d="M8.625 9.375L11.25 6.75"
        stroke="#30970B"
        stroke-width="1.125"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default SentIcon;
